@switch (hasBeenMeasured) {
    @case (true) {
        <adapt-progress-bar [percentageProgress]="currentProgress"
                            [scaleHeight]="scaleHeight"></adapt-progress-bar>
    }
    @case (false) {
        <div class="progress no-score-progress"
             [ngStyle]="{ 'height.rem': scaleHeight + 0.4 }">
            <!-- consistent progress-bar height.rem = scaleHeight + 0.4 -->
            This objective is yet to be scored.
        </div>
    }
}
